export const availableExpenses = {
  housing_expenses: {
    primaryResidenceRunningCosts: {iconName: 'primaryHome', server: 'primary_residence_running_costs'},
    strataFees: {iconName: 'strataFees', server: 'strata_fees'},
    foodAndGroceries: {iconName: 'foodAndGroceries', server: 'food_and_groceries'},
    mediaStreamingSub: {iconName: 'mediaStreamingSub', server: 'media_streaming_sub'},
    rent: {iconName: 'rent', server: 'rent'},
  },
  personal_expenses: {
    medicalAndHealth: {iconName: 'medicalAndHealth', server: 'medical_and_health'},
    clothingAndPersonalCare: {iconName: 'clothingAndPersonalCare', server: 'clothing_and_personal_care'},
    petCare: {iconName: 'petCare', server: 'pet_care'},
    recreationAndEntertainment: {iconName: 'recreationAndEntertainment', server: 'recreation_and_entertainment'},
    childCare: {iconName: 'childCare', server: 'childCare'},
    publicEducation: {iconName: 'publicEducation', server: 'public_education'},
    privateEducation: {iconName: 'primaryHome', server: 'private_education'},
    higherEducation: {iconName: 'higherEducation', server: 'higher_education'},
    transport: {iconName: 'transport', server: 'transport'},
  },
  insurance_expenses: {
    generalInsurance: {iconName: 'generalInsurance', server: 'general_insurance'},
    healthInsurance: {iconName: 'healthInsurance', server: 'health_insurance'},
    personalInsurance: {iconName: 'personalInsurance', server: 'personal_insurance'},
    investmentPropertyCosts: {iconName: 'investmentPropertyCosts', server: 'investment_property_costs'},
    secondaryResidence: {iconName: 'secondaryResidence', server: 'secondary_residence'},
    otherRunningExpenses: {iconName: 'otherRunningExpenses', server: 'other_running_expenses'},
  }
}


